export enum MainMenuOpeningModeEnum {
    over = 'over',
    side = 'side',
    push = 'push',
}